import reduceColorPointByRatio from '../../../common/utils/reduce-color-point-by-ratio';

const dark = (params) => {
  const { secondaryColor, backgroundColor, secondaryColorPalette } = params;
  const fallback = {
    rule: 'priceLabel.background.dark',
    params,
  };

  return reduceColorPointByRatio(
    {
      targetColor: secondaryColor,
      backgroundColor,
      targetColorPalette: secondaryColorPalette,
      condition: (ratio) => ratio >= 1.5,
      fallback,
    },
    '900'
  );
};

export default dark;
